<template>
    <div class="jd_sports_item4">
        <!-- 1. User Profile Section (Glassmorphic) -->
        <div class="profile_card">
            <div class="profile_left">
                <div class="avatar_wrap">
                    <img :src="userInfo.avatarurl || defaultAvatar" alt="avatar" class="avatar_img">
                </div>
                <div class="user_info">
                    <div class="user_name">Hi, {{ userInfo.name || userInfo.nickname || '小哥' }}!</div>
                    <div class="user_motto">一起运动，一起健康！</div>
                </div>
            </div>
            <div class="profile_right" v-if="detail && detail.register_mode == 2">
                <div 
                    v-if="!isRegistered || isProfessionalRegistered"
                    class="register_btn professional" 
                    :class="{ registered: isRegistered }"
                    @click="handleRegister('professional')"
                >
                    <div class="btn_icon_title">
                        <i class="btn_icon">📅</i>
                        <span>{{ isRegistered ? '已报名职业组' : '职业组报名' }}</span>
                    </div>
                    <van-icon name="arrow" class="chevron_right" v-if="!isRegistered" />
                </div>
                <div 
                    v-if="!isRegistered || isCitizenRegistered"
                    class="register_btn citizen" 
                    :class="{ registered: isRegistered }"
                    @click="handleRegister('citizen')"
                >
                    <div class="btn_icon_title">
                        <i class="btn_icon">👥</i>
                        <span>{{ isRegistered ? '已报名市民组' : '市民组报名' }}</span>
                    </div>
                    <van-icon name="arrow" class="chevron_right" v-if="!isRegistered" />
                </div>
            </div>
            <div class="profile_right" v-else>
                <div class="register_btn professional" @click="handleRegister('professional')">
                    <div class="btn_icon_title">
                        <i class="btn_icon">📅</i>
                        <span>职业组报名</span>
                    </div>
                    <van-icon name="arrow" class="chevron_right" />
                </div>
                <div class="register_btn citizen" @click="handleRegister('citizen')">
                    <div class="btn_icon_title">
                        <i class="btn_icon">👥</i>
                        <span>市民组报名</span>
                    </div>
                    <van-icon name="arrow" class="chevron_right" />
                </div>
            </div>
        </div>

        <!-- 2. Middle Navigation Grid (Leaderboard and Suggestions) -->
        <div class="middle_grid">
            <div class="grid_card rank_card" @click="goRank">
                <div class="card_info">
                    <div class="card_title rank_title">排行榜入口</div>
                    <div class="card_subtitle">查看排名赢好礼</div>
                    <div class="card_desc">运动达人榜</div>
                </div>
                <!-- Golden 3D Trophy SVG -->
                <div class="card_graphic">
                    <svg viewBox="0 0 64 64" class="trophy_svg">
                        <path d="M12,12 h40 v12 c0,10 -8,18 -20,18 c-12,0 -20,-8 -20,-18 Z" fill="#FBBF24" />
                        <path d="M22,42 v10 h20 v-10 Z" fill="#F59E0B" />
                        <path d="M16,52 h32 v4 h-32 Z" fill="#D97706" />
                        <path d="M12,16 H4 c-2,0 -4,2 -4,4 v6 c0,6 4,10 10,10 h2 Z" fill="#FBBF24" stroke="#D97706" stroke-width="2" />
                        <path d="M52,16 h8 c2,0 4,2 4,4 v6 c0,6 -4,10 -10,10 h-2 Z" fill="#FBBF24" stroke="#D97706" stroke-width="2" />
                        <circle cx="32" cy="26" r="8" fill="#FFF" opacity="0.3" />
                        <polygon points="32,20 34,24 39,24 35,27 37,32 32,29 27,32 29,27 25,24 30,24" fill="#F59E0B" />
                    </svg>
                </div>
                <div class="card_action rank_action">
                    <van-icon name="arrow" class="chevron_action" />
                </div>
            </div>

            <div class="grid_card msg_card" @click="goSuggestions">
                <div class="card_info">
                    <div class="card_title msg_title">留言建议</div>
                    <div class="card_subtitle">建言献策</div>
                    <div class="card_desc">为活动助力</div>
                </div>
                <!-- Double Chat Balloon SVG -->
                <div class="card_graphic">
                    <svg viewBox="0 0 64 64" class="msg_svg">
                        <ellipse cx="26" cy="24" rx="18" ry="14" fill="#FDA4AF" />
                        <path d="M14,35 l-6,6 v-8 c-4,-2 -6,-5 -6,-9 c0,-8 10,-14 22,-14 s22,6 22,14 s-10,14 -22,14" fill="#F43F5E" />
                        <ellipse cx="44" cy="38" rx="14" ry="11" fill="#FECDD3" />
                        <path d="M44,49 c8,0 14,-5 14,-11 s-6,-11 -14,-11 s-14,5 -14,11 c0,3 2,5 5,7 v5 l5,-4 c3,1 6,3 9,3" fill="#FB7185" />
                    </svg>
                </div>
                <div class="card_action msg_action">
                    <van-icon name="arrow" class="chevron_action" />
                </div>
            </div>
        </div>

        <!-- 3. 活动玩法 Section Title -->
        <div class="section_header">
            <div class="title_wrap">
                <span class="leaf left_leaf">🍃</span>
                <span class="title_text">活动玩法</span>
                <span class="leaf right_leaf">🍃</span>
            </div>
            <div class="subtitle_text">点击下方玩法卡片，可切换查看对应玩法规则</div>
        </div>

        <!-- 4. Gameplay Grid (2x2 Layout) -->
        <div class="gameplay_grid">
            <div 
                v-for="(mode, index) in visibleGameplayModes" 
                :key="mode.id" 
                class="gameplay_card"
                :class="[mode.themeClass, { active: mode.id === activeModeId }]"
                @click="switchMode(mode.id)"
            >
                <!-- Badge for current selection -->
                <div class="active_badge" v-if="mode.id === activeModeId">当前查看</div>
                
                <div class="mode_info">
                    <div class="mode_title">{{ mode.title }}</div>
                    <div class="mode_desc1">{{ mode.desc1 }}</div>
                    <div class="mode_desc2">{{ mode.desc2 }}</div>
                </div>

                <div class="mode_icon_wrap">
                    <!-- High-fidelity custom SVGs based on gameplay mode -->
                    <svg viewBox="0 0 64 64" class="mode_svg" v-if="mode.id === 'run'">
                        <defs>
                            <linearGradient id="runShoeGreenGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stop-color="#86EFAC" />
                                <stop offset="40%" stop-color="#22C55E" />
                                <stop offset="100%" stop-color="#15803D" />
                            </linearGradient>
                            <linearGradient id="runShoeSoleGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stop-color="#FFFFFF" />
                                <stop offset="100%" stop-color="#F1F5F9" />
                            </linearGradient>
                        </defs>
                        
                        <!-- Motion/wind lines -->
                        <line x1="4" y1="32" x2="12" y2="32" stroke="#84CC16" stroke-width="2.5" stroke-linecap="round" />
                        <line x1="2" y1="38" x2="10" y2="38" stroke="#4ADE80" stroke-width="2.5" stroke-linecap="round" />
                        <line x1="6" y1="44" x2="12" y2="44" stroke="#84CC16" stroke-width="2.5" stroke-linecap="round" />
                        
                        <!-- Heel Pull Tab -->
                        <path d="M14,24 C11,20 12,16 16,14 C19,12 18,17 17,20" fill="none" stroke="#15803D" stroke-width="2" stroke-linecap="round" />
                        
                        <!-- Main Upper Shadow/Backing -->
                        <path d="M14,36 C28,41 45,45 55,44 C53,41 51,36 46,31 C40,25 34,18 26,14 C20,18 13,26 14,36 Z" fill="#166534" />
                        
                        <!-- Green Upper Body -->
                        <path d="M15,35 C28,39 44,43 54,42 C52,39 50,34 45,29 C39,23 33,17 25,13 C23,15 21,18 19,23 C16,29 15,32 15,35 Z" fill="url(#runShoeGreenGrad)" />
                        
                        <!-- Dark Collar Lining (Ankle Opening) -->
                        <path d="M22,13 C25,12 27,15 29,17 L25,20 C23,18 21,15 22,13 Z" fill="#1E293B" />
                        
                        <!-- White Accent Swoosh/Stripe -->
                        <path d="M20,31 Q30,28 42,37 C34,31 26,29 20,31 Z" fill="#FFFFFF" opacity="0.9" />
                        <path d="M24,27 Q32,25 40,32 C34,27 28,26 24,27 Z" fill="#FFFFFF" opacity="0.6" />
                        
                        <!-- White Laces -->
                        <line x1="28" y1="17" x2="34" y2="15" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        <line x1="31" y1="21" x2="37" y2="19" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        <line x1="34" y1="25" x2="40" y2="23" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        <line x1="37" y1="29" x2="43" y2="27" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        
                        <!-- White Midsole (Thick foam sole) -->
                        <path d="M12,40 C22,46 38,50 50,50 C53,50 55,48 56,45 C46,45 30,41 14,35 C13,35 12,37 12,40 Z" fill="url(#runShoeSoleGrad)" />
                        
                        <!-- Dark Outsole (Bottom rubber tread) -->
                        <path d="M12,40 C22,46 38,50 50,50 C48,51 38,51 22,47 C15,44 12,41 12,40 Z" fill="#1E293B" />
                    </svg>

                    <svg viewBox="0 0 64 64" class="mode_svg" v-else-if="mode.id === 'quiz'">
                        <!-- Shining Lightbulb -->
                        <path d="M32,10 C20,10,14,18,14,28 C14,34,18,38,22,42 L22,48 L42,48 L42,42 C46,38,50,34,50,28 C50,18,44,10,32,10 Z" fill="#FEF08A" stroke="#EAB308" stroke-width="2" />
                        <path d="M26,48 h12 v4 h-12 Z" fill="#9CA3AF" />
                        <path d="M28,52 h8 v4 h-8 Z" fill="#6B7280" />
                        <path d="M32,22 C30,22,28,24,28,26" fill="none" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" />
                        <!-- Shining rays -->
                        <line x1="32" y1="2" x2="32" y2="6" stroke="#EAB308" stroke-width="3" stroke-linecap="round" />
                        <line x1="12" y1="12" x2="16" y2="16" stroke="#EAB308" stroke-width="3" stroke-linecap="round" />
                        <line x1="52" y1="12" x2="48" y2="16" stroke="#EAB308" stroke-width="3" stroke-linecap="round" />
                        <line x1="6" y1="28" x2="10" y2="28" stroke="#EAB308" stroke-width="3" stroke-linecap="round" />
                        <line x1="58" y1="28" x2="54" y2="28" stroke="#EAB308" stroke-width="3" stroke-linecap="round" />
                        <!-- Question Mark on bulb -->
                        <text x="32" y="34" font-size="16" font-family="sans-serif" font-weight="900" text-anchor="middle" fill="#CA8A04">?</text>
                    </svg>

                    <svg viewBox="0 0 64 64" class="mode_svg" v-else-if="mode.id === 'clock'">
                        <!-- Clapperboard -->
                        <rect x="8" y="20" width="48" height="34" rx="4" fill="#3B82F6" />
                        <polygon points="8,12 56,8 56,20 8,20" fill="#1D4ED8" />
                        <!-- White slashes on clapper top -->
                        <line x1="16" y1="20" x2="24" y2="12" stroke="#FFF" stroke-width="4" />
                        <line x1="32" y1="20" x2="40" y2="12" stroke="#FFF" stroke-width="4" />
                        <line x1="48" y1="20" x2="54" y2="14" stroke="#FFF" stroke-width="4" />
                        <!-- Video Play symbol -->
                        <polygon points="26,28 44,37 26,46" fill="#FFF" />
                    </svg>

                    <svg viewBox="0 0 64 64" class="mode_svg" v-else-if="mode.id === 'lucky'">
                        <!-- Lucky Wheel -->
                        <circle cx="32" cy="32" r="24" fill="#EF4444" stroke="#F59E0B" stroke-width="3" />
                        <circle cx="32" cy="32" r="18" fill="#FFFBEB" />
                        <!-- Wheel segments -->
                        <line x1="32" y1="8" x2="32" y2="56" stroke="#F59E0B" stroke-width="2" />
                        <line x1="8" y1="32" x2="56" y2="32" stroke="#F59E0B" stroke-width="2" />
                        <line x1="15" y1="15" x2="49" y2="49" stroke="#F59E0B" stroke-width="2" />
                        <line x1="15" y1="49" x2="49" y2="15" stroke="#F59E0B" stroke-width="2" />
                        <!-- Pointer at center -->
                        <polygon points="32,20 36,32 28,32" fill="#DC2626" />
                        <circle cx="32" cy="32" r="4" fill="#CA8A04" />
                    </svg>
                </div>

                <!-- Color-matched action chevron -->
                <div class="mode_action_chevron" :style="{ backgroundColor: mode.chevronColor }">
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>

        <!-- 5. Bottom Rule Panel & Dynamic/Static CTA Button -->
        <div class="rule_panel" v-if="activeMode">
            <div class="panel_header">
                <div class="panel_title">{{ activeMode.ruleTitle }}</div>
                <div class="panel_header_sub">点击上方不同玩法，可切换查看对应规则</div>
            </div>

            <div class="panel_content">
                <div class="rule_graphic_wrap">
                    <!-- Document Clipboard Icon -->
                    <svg viewBox="0 0 64 64" class="clipboard_svg">
                        <rect x="14" y="10" width="36" height="46" rx="4" fill="#FFF" stroke="#FF7E00" stroke-width="2" />
                        <rect x="22" y="6" width="20" height="8" rx="2" fill="#FED7AA" stroke="#FF7E00" stroke-width="2" />
                        <line x1="22" y1="24" x2="42" y2="24" stroke="#E2E8F0" stroke-width="3" stroke-linecap="round" />
                        <line x1="22" y1="32" x2="42" y2="32" stroke="#E2E8F0" stroke-width="3" stroke-linecap="round" />
                        <line x1="22" y1="40" x2="34" y2="40" stroke="#E2E8F0" stroke-width="3" stroke-linecap="round" />
                        <!-- Question Badge -->
                        <circle cx="46" cy="46" r="10" fill="#FF7E00" />
                        <text x="46" y="51" font-size="14" font-family="sans-serif" font-weight="bold" text-anchor="middle" fill="#FFF">?</text>
                    </svg>
                </div>

                <ul class="rules_bullets">
                    <li v-for="(bullet, index) in activeMode.rules" :key="index">
                        <span class="bullet_dot"></span>
                        <span class="bullet_text">{{ bullet }}</span>
                    </li>
                </ul>
            </div>

            <!-- Big wide Orange Gradient CTA button -->
            <div class="cta_action_wrap">
                <div class="cta_btn" @click="handlePlayModeClick(activeMode)">
                    <span>{{ activeMode.btnText }}</span>
                    <van-icon name="arrow" class="cta_chevron" />
                </div>
            </div>
        </div>

        <!-- Popups and Modals (Preserved from Index2/Index3 for full logic integrity) -->
        <van-popup closeable round v-model="showform" class="register-form-popup">
            <div class="popup_header">
                <div class="popup_title">完善报名信息</div>
                <div class="popup_subtitle">请确认您的参赛组别及联系方式</div>
            </div>
            <div class="popup_body">
                <Form 
                    :list="attrs" 
                    :ispop="true" 
                    buttonColor="linear-gradient(180deg, #ff7e00 0%, #ff5e00 100%)"  
                    @submit="submit"
                />
            </div>
        </van-popup>

        <van-dialog
            v-model="showRule"
            class="sports_item_rule_dialog rule"
            :show-confirm-button="false"
            close-on-click-overlay
        >
            <van-icon
                name="close"
                style="position: fixed; right: .2rem; top: .2rem; z-index: 10;"
                size=".4rem"
                @click="showRule = false"
            />
            <div class="rule_content">
                <div class="rule_title">{{ title || '玩法攻略' }}</div>
                <div class="rule_html" v-html="rule"></div>
            </div>
        </van-dialog>

        <van-action-sheet 
            v-model="showRegisterSheet" 
            :actions="registerActions" 
            @select="onRegisterSelect" 
            cancel-text="取消" 
            close-on-click-action 
        />

        <!-- Registration Reminder Popup -->
        <van-popup 
            v-model="showRegisterReminder" 
            round 
            :close-on-click-overlay="false" 
            class="register-reminder-popup"
        >
            <div class="reminder_header">
                <div class="reminder_icon">
                    <svg viewBox="0 0 64 64" class="info_svg">
                        <circle cx="32" cy="32" r="30" fill="none" stroke="#ff7e00" stroke-width="4" />
                        <path d="M32 18 v20" stroke="#ff7e00" stroke-width="5" stroke-linecap="round" />
                        <circle cx="32" cy="48" r="3.5" fill="#ff7e00" />
                    </svg>
                </div>
                <div class="reminder_title">报名提示</div>
            </div>
            <div class="reminder_body">
                <div class="reminder_text_wrapper">
                    <p class="reminder_para para_highlight">
                        若您选择报名<span class="highlight">职业组</span>，如进入获奖名单，领奖前需按要求补充提交寄递小哥、物流司机等新就业形态劳动者的职业身份证明并完成资格核验。
                    </p>
                    <p class="reminder_para">
                        同时，为确保获奖信息真实有效，职业组和市民组获奖人员领奖前均需提交身份证信息进行身份核验。若发现同一身份证重复获奖、信息无效、未按要求提交材料，或职业组资格核验未通过，将取消相应获奖资格，奖励名额按规则顺延。
                    </p>
                    <p class="reminder_confirm_text">
                        请您确认参与条件后继续报名。
                    </p>
                </div>
            </div>
            <div class="reminder_footer">
                <button class="reminder_btn btn_cancel" @click="showRegisterReminder = false">我再想想</button>
                <button class="reminder_btn btn_confirm" @click="confirmRegister">确认并继续</button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import "./item.less";
import Form from '@/components/form/popform.vue'
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag, Popup, ActionSheet } from "vant";

export default {
    components: {
        Empty,
        Cell,
        CellGroup,
        Skeleton,
        Button,
        VanImage: Image,
        Tag,
        Popup,
        Form,
        vanActionSheet: ActionSheet
    },
    props: ["item", "detail", "sports_id", "items"],
    data() {
        return {
            showRegisterReminder: false,
            pendingRegisterType: "",
            showRule: false,
            subItemList: [],
            title: "",
            rule: "",
            enableActivity: false,
            scoreType: 1,
            content: "",
            canjoin: "",
            userInfo: {},
            attrs: [],
            registerinfos: null,
            showform: false,
            showRegisterSheet: false,
            registerActions: [
                { name: '职业组报名', type: 'professional' },
                { name: '市民组报名', type: 'citizen' }
            ],
            defaultAvatar: "https://oss.mcloud.moveclub.cn/2025/qjyd-hu/%E6%A4%AD%E5%9C%86%20250%402x.png", // Fallback avatar

            // High Fidelity Gameplay modes data
            activeModeId: 'quiz', // Default selected mode in the design image is '知识问答'
            gameplayModes: [
                {
                    id: 'run',
                    title: '线上跑',
                    desc1: '累计步数',
                    desc2: '解锁健康点位',
                    chevronColor: '#22c55e',
                    themeClass: 'theme_green',
                    ruleTitle: '线上跑规则',
                    rules: [
                        '活动期间，系统将自动同步微信运动步数。',
                        '累计步数每满5000步，可解锁1个健康知识点位。',
                        '本次活动共设置12个点位，累计60000步可解锁全部点位。',
                        '每解锁1个点位，可获得对应积分，并增加1次抽奖机会。'
                    ],
                    btnText: '参与线上跑',
                    apiItem: null
                },
                {
                    id: 'quiz',
                    title: '知识问答',
                    desc1: '答题涨知识',
                    desc2: '积分轻松拿',
                    chevronColor: '#f97316',
                    themeClass: 'theme_orange',
                    ruleTitle: '知识问答规则',
                    rules: [
                        '活动期间每日开放1组健康安全知识问答。',
                        '每组共5题，内容涵盖运动安全、出行安全、防暑降温等。',
                        '每答对1题可获得对应积分，每日完成1组答题可获得1次抽奖机会。',
                        '每名用户每日仅可获得1次答题积分，重复答题不重复计分。'
                    ],
                    btnText: '参与知识问答',
                    apiItem: null
                },
                {
                    id: 'clock',
                    title: '运动打卡',
                    desc1: '跟练八段锦',
                    desc2: '上传运动视频',
                    chevronColor: '#3b82f6',
                    themeClass: 'theme_blue',
                    ruleTitle: '运动打卡规则',
                    rules: [
                        '用户可观看参考视频，完成八段锦等运动实践内容。',
                        '每日可上传1次运动打卡视频，视频需与活动动作内容相关。',
                        '上传后需经后台审核，审核通过后获得积分。',
                        '审核通过的运动打卡，可获得1次抽奖机会。',
                        '无关视频、重复视频、画面无法判断动作完成情况的视频，不计入有效打卡。'
                    ],
                    btnText: '参与运动打卡',
                    apiItem: null
                },
                {
                    id: 'lucky',
                    title: '立即抽奖',
                    desc1: '惊喜好礼等你来拿',
                    desc2: '大轮盘抽奖',
                    chevronColor: '#f97316',
                    themeClass: 'theme_red',
                    ruleTitle: '立即抽奖规则',
                    rules: [
                        '活动期间，完成指定任务即可获得抽奖机会。',
                        '解锁1个线上跑点位，可获得1次抽奖机会。',
                        '每日完成1组知识问答，可获得1次抽奖机会。',
                        '每日上传运动打卡视频并审核通过，可获得1次抽奖机会。'
                    ],
                    btnText: '立即抽奖',
                    apiItem: null
                }
            ]
        };
    },
    computed: {
        activeMode() {
            return this.visibleGameplayModes.find(mode => mode.id === this.activeModeId);
        },
        visibleGameplayModes() {
            const itemsList = this.items || [];
            return this.gameplayModes.filter(mode => {
                if (mode.id === 'lucky') {
                    return true;
                }
                let hasMatch = false;
                if (mode.id === 'run') {
                    hasMatch = itemsList.some(x => +x.type === 5);
                } else if (mode.id === 'quiz') {
                    hasMatch = itemsList.some(x => +x.type === 2);
                } else if (mode.id === 'clock') {
                    hasMatch = itemsList.some(x => +x.type === 4);
                }
                return hasMatch;
            });
        },
        isRegistered() {
            if (this.detail && this.detail.register_mode == 2) {
                return !!this.detail.is_registered;
            }
            return !!this.registerinfos;
        },
        registeredInfo() {
            if (this.detail && this.detail.register_mode == 2) {
                return this.detail.registered_info;
            }
            return null;
        },
        isProfessionalRegistered() {
            if (!this.isRegistered || !this.registeredInfo) return false;
            const regType = this.registeredInfo.register_type;
            return regType == 1 || regType === '职业组' || (typeof regType === 'string' && regType.includes('职业'));
        },
        isCitizenRegistered() {
            if (!this.isRegistered || !this.registeredInfo) return false;
            const regType = this.registeredInfo.register_type;
            return regType == 2 || regType === '市民组' || (typeof regType === 'string' && regType.includes('市民'));
        }
    },
    watch: {
        item: {
            handler: "getItemInfo",
            immediate: true,
            deep: true,
        },
        visibleGameplayModes: {
            handler(newModes) {
                if (newModes && newModes.length > 0) {
                    const exists = newModes.some(m => m.id === this.activeModeId);
                    if (!exists || (this.activeModeId === 'lucky' && newModes.length > 1)) {
                        const firstNonLucky = newModes.find(m => m.id !== 'lucky');
                        this.activeModeId = firstNonLucky ? firstNonLucky.id : newModes[0].id;
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.getUserInfo();
        this.getother();
    },
    methods: {
        switchMode(modeId) {
            this.activeModeId = modeId;
        },
        submit: function (e) {
            this.$dialog.confirm({
                title: "提示",
                confirmButtonText: '确定提交',
                message: '信息提交后不可修改,确定提交?',
                showCancelButton: true
            }).then(() => {
                if (this.detail && this.detail.register_mode == 2) {
                    let params = {
                        sports_id: this.sports_id,
                        registerInfo: e
                    };
                    this.$api.sports.registerSports(params).then((res) => {
                        if (res && +res.status === 200) {
                            if (this.$parent && typeof this.$parent.init === 'function') {
                                this.$parent.init();
                            }
                            this.showform = false;
                            this.$toast.success("报名成功！");
                        } else {
                            this.$toast.fail(res.message || "报名失败");
                        }
                    }).catch(err => {
                        this.$toast.fail("请求失败，请稍后重试");
                    });
                } else {
                    this.$api.activity.submitCombine({
                        registerinfos: JSON.stringify(e),
                        combile_id: 52
                    }).then((res) => {
                        if (res && +res.status === 200) {
                            this.getother();
                            this.showform = false;
                            this.$toast.success("报名成功！");
                        }
                    });
                }
            }).catch(() => {});
        },
        getother: function () {
            if (this.detail && this.detail.register_mode == 2) {
                return;
            }
            this.$api.activity.memberAttrList({ typeid: 1688 }).then((res) => {
                if (res && res.data && res.data.list && res.data.list[0]) {
                    this.attrs = res.data.list[0]['attrs'];
                }
            }).catch(e => console.warn(e));

            this.$api.activity.getCombine({ combile_id: 52 }).then((res) => {
                if (res && res.data) {
                    let { registerinfos } = res.data;
                    this.registerinfos = registerinfos ? registerinfos : null;
                }
            }).catch(e => console.warn(e));
        },
        getUserInfo() {
            this.$api.user.getUserInfo().then((res) => {
                if (res && res.status * 1 === 200) {
                    this.userInfo = res.data;
                }
            }).catch(e => console.warn(e));
        },
        onRegisterSelect(item) {
            this.handleRegister(item.type);
        },
        handleRegister(type) {
            if (this.isRegistered) {
                this.$toast("您已报名该赛事！");
                return;
            }
            this.pendingRegisterType = type;
            this.showRegisterReminder = true;
        },
        confirmRegister() {
            this.showRegisterReminder = false;
            this.proceedRegister(this.pendingRegisterType);
        },
        proceedRegister(type) {
            if (this.detail && this.detail.register_mode == 2) {
                try {
                    let formSchema = JSON.parse(this.detail.registerform);
                    if (formSchema && formSchema[0] && formSchema[0].attrs) {
                        let attrs = JSON.parse(JSON.stringify(formSchema[0].attrs));
                        attrs.forEach(attr => {
                            if (attr.key_name === 'register_type') {
                                let options = [];
                                if (typeof attr.options === 'string') {
                                    try {
                                        options = JSON.parse(attr.options);
                                    } catch (e) {}
                                } else if (Array.isArray(attr.options)) {
                                    options = attr.options;
                                }

                                let matchedOption = null;
                                if (type === 'professional') {
                                    matchedOption = options.find(opt => opt.value.includes('职业') || opt.value.includes('专业'));
                                    attr.value = matchedOption ? matchedOption.value : '职业组';
                                } else {
                                    matchedOption = options.find(opt => opt.value.includes('市民') || opt.value.includes('大众') || opt.value.includes('普通'));
                                    attr.value = matchedOption ? matchedOption.value : '市民组';
                                }
                                attr.disabled = true;
                            }
                        });
                        this.attrs = attrs;
                        this.showform = true;
                    } else {
                        this.$toast("暂未配置报名表单");
                    }
                } catch (e) {
                    console.error(e);
                    this.$toast("表单配置解析错误");
                }
            } else {
                this.showform = true;
            }
        },
        goRank() {
            // Push to jd_rank matching the current active sports ID
            this.$router.push({
                name: 'jd_rank',
                params: {
                    activity_id: this.sports_id || this.item.sports_id || 1353
                }
            });
        },
        goSuggestions() {
            if (this.detail && +this.detail.is_comment === 1) {
                this.$router.push({
                    name: 'jd_comment',
                    params: {
                        sports_id: this.sports_id || (this.item && this.item.sports_id)
                    }
                });
            } else {
                this.$toast("留言建议功能未开启");
            }
        },
        handlePlayModeClick(mode) {
            if (!mode) return;

            // Check registration
            if (!this.isRegistered) {
                this.$dialog.alert({
                    title: "提示",
                    message: "您需要先报名才能参与活动！"
                }).then(() => {
                    if (this.detail && this.detail.register_mode == 2) {
                        this.showRegisterSheet = true;
                    } else {
                        this.handleRegister('citizen');
                    }
                });
                return;
            }

            if (mode.id === 'lucky') {
                const luckdrawAcid = this.detail ? this.detail.luckdraw_acid : null;
                if (!luckdrawAcid) {
                    this.$toast("抽奖活动未配置");
                    return;
                }
                this.$router.push({
                    name: 'luckdraw',
                    params: {
                        acid: luckdrawAcid
                    }
                });
                return;
            }

            const itemsList = this.items || [];
            let matchedItem = null;
            if (mode.id === 'run') {
                matchedItem = itemsList.find(x => +x.type === 5);
            } else if (mode.id === 'quiz') {
                matchedItem = itemsList.find(x => +x.type === 2);
            } else if (mode.id === 'clock') {
                matchedItem = itemsList.find(x => +x.type === 4);
            }

            if (!matchedItem) {
                this.$toast("活动暂未开放，敬请期待！");
                return;
            }

            // If we are currently viewing this item's tab and already have apiItem, use it
            if (this.item && +this.item.id === +matchedItem.id && mode.apiItem) {
                if (+mode.apiItem.state === 2) {
                    this.$toast('活动已结束');
                    return;
                }
                this.goDetail(mode.apiItem);
                return;
            }

            // Otherwise, fetch sub-items for this matched item dynamically
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0,
            });

            this.$api.sports.getItemSubs({ itemid: matchedItem.id }).then((res) => {
                this.$toast.clear();
                if (res && res.data && res.data.list && res.data.list.length > 0) {
                    const subItem = res.data.list[0];
                    if (+subItem.state === 2) {
                        this.$toast('活动已结束');
                        return;
                    }
                    
                    // If it is a Q&A activity (quiz, type=2), navigate directly to the answer page if it has an activity_id
                    if (mode.id === 'quiz' && subItem.activity_id) {
                        this.$router.push({
                            name: 'newanswer',
                            params: {
                                acid: subItem.activity_id,
                                sub_aid: subItem.id
                            }
                        });
                        return;
                    }

                    // Otherwise, use standard goDetail logic
                    this.goDetail(subItem);
                } else {
                    // Fallback to item page if no sub-items
                    this.$router.push({
                        name: 'jd_item',
                        params: {
                            item_id: matchedItem.id
                        }
                    });
                }
            }).catch(err => {
                this.$toast.clear();
                console.error("Failed to load sub-activity:", err);
                // Fallback to item page
                this.$router.push({
                    name: 'jd_item',
                    params: {
                        item_id: matchedItem.id
                    }
                });
            });
        },
        goDetail(val) {
            if (val.register_type_value) {
                if (val.register_type_value.indexOf('http') != -1) {
                    window.location.href = val.register_type_value;
                } else {
                    if (typeof wx !== 'undefined' && wx.miniProgram) {
                        wx.miniProgram.navigateTo({
                            url: val.register_type_value
                        });
                    } else {
                        this.$toast("请在微信小程序中打开此功能");
                    }
                }
                return;
            }
            this.$router.push({
                name: 'sportsDetail',
                params: {
                    sports_id: val.sports_id,
                    item_id: val.sports_item_id || this.item.id,
                    item_sub_id: val.id
                }
            });
        },
        getItemInfo() {
            if (!this.item || !this.item.id) return;

            // Auto select activeModeId in "活动玩法" matching the current item's type
            if (this.item.type) {
                if (+this.item.type === 5) {
                    this.activeModeId = 'run';
                } else if (+this.item.type === 2) {
                    this.activeModeId = 'quiz';
                } else if (+this.item.type === 4) {
                    this.activeModeId = 'clock';
                }
            }

            this.subItemList = [];
            this.rule = "";
            this.enableActivity = false;

            this.$api.sports.getItemSubs({ itemid: this.item.id }).then((res) => {
                if (res && res.data) {
                    this.subItemList = res.data.list || [];
                    this.title = res.data.title || "";
                    this.content = res.data.content || "";
                    this.rule = res.data.rule || "";
                    this.scoreType = res.data.score_type || 1;
                    this.canjoin = res.data.canjoin || "";
                    
                    // Sync backend subItemList with our 2x2 gameplay tabs
                    this.syncSubItems();
                    
                    if (res.data.list && +res.data.list.length === 1) {
                        let { start_time } = res.data.list[0];
                        this.enableActivity = res.sys_time > start_time;
                    }
                }
            }).catch((err) => {
                console.error("Failed to load sub-activities:", err);
            });
        },
        syncSubItems() {
            this.gameplayModes.forEach(mode => {
                let matchedItem = null;
                if (this.subItemList && this.subItemList.length > 0) {
                    if (mode.id === 'run') {
                        matchedItem = this.subItemList.find(x => x.title.includes('跑') || x.title.includes('步') || x.title.toLowerCase().includes('run'));
                    } else if (mode.id === 'quiz') {
                        matchedItem = this.subItemList.find(x => x.title.includes('答') || x.title.includes('问') || x.title.includes('知识') || x.title.toLowerCase().includes('quiz') || x.title.toLowerCase().includes('answer'));
                    } else if (mode.id === 'clock') {
                        matchedItem = this.subItemList.find(x => x.title.includes('打卡') || x.title.includes('视频') || x.title.toLowerCase().includes('clock') || x.title.toLowerCase().includes('video'));
                    } else if (mode.id === 'lucky') {
                        matchedItem = this.subItemList.find(x => x.title.includes('抽') || x.title.includes('奖') || x.title.toLowerCase().includes('lucky') || x.title.toLowerCase().includes('draw') || x.title.toLowerCase().includes('lottery'));
                    }
                }
                mode.apiItem = matchedItem;
                
                // Overlay DB rules if matched
                if (matchedItem && matchedItem.rule) {
                    try {
                        let rulesFromDb = matchedItem.rule.split(/<br\s*\/?>|\n/).filter(x => x.trim().length > 0);
                        if (rulesFromDb.length > 0) {
                            mode.rules = rulesFromDb.map(x => x.replace(/^\d+、|^\d+\.|^一、|^二、|^三、|^四、/, '').trim());
                        }
                    } catch (e) {
                        console.warn("Error parsing rule from DB:", e);
                    }
                }
            });
        }
    }
}
</script>
